// extracted by mini-css-extract-plugin
var _1 = "MOWzwC1yajCsQv1YEUYh";
var _2 = "MOWzwC1yajCsQv1YEUYh";
var _3 = "egxM6cpsVvfO682_rBMz";
var _4 = "egxM6cpsVvfO682_rBMz";
var _5 = "X1tLFxTNNds3IrTB4Ozz";
var _6 = "X1tLFxTNNds3IrTB4Ozz";
export { _1 as "add-education-button", _2 as "addEducationButton", _3 as "form-bottom-margin", _4 as "formBottomMargin", _5 as "no-bottom-padding", _6 as "noBottomPadding" }
